/**
 * グローバル変数
 */
window.ohValidate = {};

/**
 * バリデーション設定と実行
 */
$(function(){
  // 追加バリデーション
  addCustomValidation();

  // バリデーション定義
  var $form = $('form');
  $('form').validate({
    onfocusout: false,
    onkeyup: false,
    onclick: false,
    groups:window.ohValidateGlp,
    rules:window.ohValidateRul,
    messages:window.ohValidateMsg,
    errorPlacement:errPlacement,
    success:removeErrPlacement,
    highlight: highlight,
    unhighlight: unhighlight,
    invalidHandler: invalidHandler,
  });

  // checkbox,radio はsubmit時にしかバリデートされない仕様のため
  // 値が変更されたらバリデートするよう設定
  $('input[type="radio"], select, input.js-datepicker').on('change', function() {$(this).valid();});
  $('input[type="checkbox"]').on('click', function() {$(this).valid();});
  $('input[type="text"], input[type="password"], input[type="email"], input[type="number"], input[type="tel"], textarea').on('blur', function() {$(this).valid();});

});

/**
 * validate option
 *
 * エラー表示位置設定
 * @param {*} error
 * @param {*} element
 */
var errPlacement = function(error, element) {
  console.log(error);
  var el = $(element).closest('.c-form-item__inner').siblings('.js-form-item-error');
  if(!el.length) {
    el = $(element).closest('.c-form-item__input-row').siblings('.js-form-item-error');
  }

  el.empty();
  error.appendTo(el);
};

/**
 * validate option
 *
 * エラー表示位置設定
 * @param {*} error
 * @param {*} element
 */
var removeErrPlacement = function(error, element) {
  // var el = $(element).closest('.c-form-item__inner').siblings('.js-form-item-error');
  // if(!el.length) {
  //   el = $(element).closest('.c-form-item__input-row').siblings('.js-form-item-error');
  // }
  //
  // el.empty();
}

/**
 * validate option
 *
 * エラー検出時のハンドリング
 * @param {*} element
 * @param {*} errorClass
 */
var highlight = function(element, errorClass) {
  $(element).parents('.c-form-item__inner').siblings('.js-form-item-error').addClass("test-error");
};

/**
 * validate option
 *
 * エラー未検出時のハンドリング
 * @param {*} element
 * @param {*} errorClass
 */
var unhighlight = function(element, errorClass) {
  $(element).parents('.c-form-item__inner').siblings('.js-form-item-error').removeClass("test-error");
}

/**
 * validate option
 *
 * submit時のエラーハンドリング
 * @param {*} form
 * @param {*} validator
 */
var invalidHandler = function(form, validator) {};

/**
 * validate option
 *
 * 追加バリデーション
 */
function addCustomValidation(){

  // 半角変換関数
  var oh_change_hankaku = window.ohValidateChangehankaku;

  // ふりがな
  $.validator.addMethod(
    'kana',
    function(value, element) {
      return this.optional(element) || /^([ぁ-ん]|\s|　|・|ー|ヽ|ヾ|゛|゜|ゝ|ゞ|－|～|)+$/.test(value);
    }
  );
  // 正規表現
  $.validator.addMethod(
    'regex',
    function(value, element, params){
      const regex = RegExp(params);
      return this.optional(element) || regex.test(value);
    }
  );
  // 数値
  $.validator.addMethod(
    "digits_check_no",
    function(value, element, params) {
      var not_digits = 0;

      $.each(params,function(index, ele) {
        // if ($(ele).prop('tagName') === 'SELECT') {
        //   var param_org = $(ele+" option:selected").text();
        // } else {
        //   var param_org = $(ele).val();
        // }
        var param_org = $(ele).val();
        var param = oh_change_hankaku(param_org);
        if (param.match(/^[0-9]+$/) || oh_check_blank(param)) {
        } else {
          not_digits++;
        }
      });

      if (not_digits >= 1) {
        return false;
      } else {
        return true;
      }

    }
  );
  // 数値比較
  $.validator.addMethod(
    "compare_number",
    function(value, element, params) {
      // if ($(element).prop('tagName') === 'SELECT') {
      //   var min = parseInt(oh_change_hankaku($(params[0]+" option:selected").text()), 10);
      //   var max = parseInt(oh_change_hankaku($(params[1]+" option:selected").text()), 10);
      // } else {
      //   var min = parseInt(oh_change_hankaku($(params[0]).val()), 10);
			// 	var max = parseInt(oh_change_hankaku($(params[1]).val()), 10);
      // }
      var min = parseInt(oh_change_hankaku($(params[0]).val()), 10);
      var max = parseInt(oh_change_hankaku($(params[1]).val()), 10);

      if (min > max) {
        return false;
      } else {
        return true;
      }
    },
  );
  // セレクトボックスvalueの文字列長
  $.validator.addMethod(
    "select_val_rangelength",
    function( value, element, param ) {
      var length = value.length;
      return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
    }
  );

  // // 数値
  // $.validator.addMethod(
  //   "decimal",
  //   function(value, element) {
  //     var focus_id = $(':focus').attr('id');
  //     if (focus_id == $(element).attr('id')) {
  //       return this.optional(element) || /^[0-9]+.?([0-9]{1,2})?$/.test(oh_change_hankaku(value));
  //     }
  //     return this.optional(element) || /^[0-9]+(\.[0-9]{1,2})?$/.test(oh_change_hankaku(value));
  //   },
  // );
  // // 数値
  // $.validator.addMethod(
  //   "decimal2",
  //   function(value, element) {
  //     return this.optional(element) || /^[0-9]+(\.[0-9]{1,2})?$/.test(oh_change_hankaku(value));
  //   },
  // );
}

/**
 * utility
 *
 * 未入力チェック(スペースのみの場合も未入力とする)
 *
 * @param {*} value
 * @retun true: 未入力, false: 入力あり
 */
var oh_check_blank = function(value) {
	return value === '' || value.match(/^[\s|　]+$/) != null;
}

/**
 * utility (グローバル)
 *
 * バリデーションメッセージの取得
 * @param string messageKey メッセージキー
 * @param string attribute 項目名
 * @param object replace その他置換対象
 * @return メッセージ
 */
window.ohValidateGetMsg = function (messageKey, attribute = '', replace = {})
{
  // メッセージリストから、messageKeyに対応した文字列を取得
  var message = window.ohValidateMsgList;
  var messageKeyArray = messageKey.split('.');
  for (let i = 0; i < messageKeyArray.length; i++) {
    message = message[messageKeyArray[i]];
  }

  // 文字列が取得できない場合
  if (typeof message !== 'string') { return ''; }

  // メッセージにパラメータ差し込み　：　attribute
  message = message.replace(':attribute',attribute);

  // メッセージにパラメータ差し込み　：　replace
  Object.keys(replace).forEach(function (k) {
    message = message.replace(':' + k, replace[k]);
  });

  return message;
}

/**
 * utility (グローバル)
 *
 * スペースのみの入力値を空文字に変換
 *
 * @param {*} value
 */
window.ohValidateChangeBlank = function(value) {
	return value.replace(/^[\s|　]+$/,'');
}

/**
 * utility (グローバル)
 *
 * 全角英数字⇒半角英数字
 *
 * @param {*} param
 */
window.ohValidateChangehankaku = function(param) {
	var zenkigou = "＠－ー＋＿．，、";
	var hankigou = "@--+_...";
	var str = "";

	// 指定された全角記号のみを半角に変換
	for (i = 0; i < param.length; i++) {
		var dataChar = param.charAt(i);
		var dataNum = zenkigou.indexOf(dataChar, 0);
		if (dataNum >= 0)
			dataChar = hankigou.charAt(dataNum);
		str += dataChar;
	}
	return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
		return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}
